module.exports = __webpack_public_path__ + "media/images/countrysquared/im-e1d8299df15f9829d1a66f26fe349571.svg";